module.exports = __webpack_public_path__ + "img/home-filling.7b823b3c.svg";